export default "__VITE_ASSET__g9Zj3fpl__"